// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes timer-pulse-4d529691{0%{box-shadow:0 0 0 0 rgba(122,204,51,.6)}70%{box-shadow:0 0 0 10px rgba(204,169,44,0)}to{box-shadow:0 0 0 0 rgba(204,169,44,0)}}.icon-wrapper[data-v-4d529691]{display:flex;justify-content:center;width:100%}.icomoon-exchange[data-v-4d529691]{color:#d3d8d9;font-size:1.25rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
